export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12010.ecde0680.jpg";